module.exports = __webpack_public_path__ + "static/media/robot-top-shadow.434f7b4f.svg";